import { Typography } from '@mui/material';
import clsx from 'clsx';
import React, { FC } from 'react';

import { useStyles } from '../../styles';

type Props = {
  text: string,
  className?: string
}

export const Description: FC<Props> = ({ text, className }) => {
  const classes = useStyles();
  return (<Typography className={clsx(classes.tableTitle, className)} variant="subtitle2">{text}</Typography>);
};
